export enum View {
  KYB = "KYB",
  Billing = "Billing",
  Default = "Default",
  IDV = "IDV"
}

export enum StepStatus {
  pending = "Under review",
  verified = "Completed",
  finished = "Completed",
  approved = "Approved",
  failed = "Failed",
  rejected = "Rejected"
}

export type OnboardingData = {
  billing: {
    bank_account_required: boolean;
    ach_link: string;
    plaid_link: string;
  };
  identity_verification: {
    id: number;
    status: "finished" | "pending" | "failed";
    customer: null | unknown;
    shareable_url: string;
    created_at: string;
  };
  identity_verification_status: "verified" | "pending" | "failed";
  kyb_verification: {
    status: "pending" | "approved" | "rejected";
    created_at: string;
    id: number;
    kyb_response_id: string;
  } | null;
};
